export const updateChargingValue = (state, action) => {
    state.chargingValues = action.payload;
};

export const updateStopChargingStatus = (state, action) => {
    state.stopChargingStatus = action.payload;
};
